var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { useOfferColumns } from '../../../hooks/useColumns';
import LabeledGridItem from '../../atoms/LabeledGridItem';
import MaterialTable from '../../MaterialTable';
import { formatDateTimeWithOffset } from '../../../utils/format';
import { useNavigate } from 'react-router-dom';
import { AuctionIcon } from '../../atoms/Icons';
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-root {\n    padding: 0 24px;\n    margin-bottom: 20px;\n  }\n"], ["\n  &.MuiGrid-root {\n    padding: 0 24px;\n    margin-bottom: 20px;\n  }\n"])));
var OfferListDetail = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var OfferColumns = useOfferColumns('producer');
    var columns = React.useMemo(function () { return [
        OfferColumns.lotRef,
        OfferColumns.bagmark,
        OfferColumns.originType,
        OfferColumns.farm,
        OfferColumns.producerName,
        OfferColumns.region,
        OfferColumns.district,
        OfferColumns.altitude,
        OfferColumns.farmSize,
        OfferColumns.variety,
        OfferColumns.grade,
        OfferColumns.processing,
        OfferColumns.processingMethod,
        OfferColumns.harvestYear,
        OfferColumns.harvestMonth,
        OfferColumns.stockAmount,
        OfferColumns.totalSampleQuantity,
        OfferColumns.ordersCount,
        __assign(__assign({}, OfferColumns.ordersTotalQuantity), { render: function (_a) {
                var _b = _a.ordersTotalQuantity, ordersTotalQuantity = _b === void 0 ? 0 : _b, _c = _a.typicaStockTotalQuantity, typicaStockTotalQuantity = _c === void 0 ? 0 : _c;
                return ordersTotalQuantity + typicaStockTotalQuantity;
            } }),
        __assign(__assign({}, OfferColumns.ordersTotalWeight), { render: function (_a) {
                var _b = _a.ordersTotalWeight, ordersTotalWeight = _b === void 0 ? 0 : _b, _c = _a.typicaStockTotalWeight, typicaStockTotalWeight = _c === void 0 ? 0 : _c;
                return (Number(ordersTotalWeight) + Number(typicaStockTotalWeight)).toFixed(1);
            } }),
        OfferColumns.fobPrice,
        OfferColumns.bagSize,
        OfferColumns.package,
        OfferColumns.producerComment,
    ]; }, [OfferColumns]);
    var publishedCountries = React.useMemo(function () {
        return offerList.publishedCountries
            .map(function (_a) {
            var code = _a.code;
            return t("countries.".concat(code));
        })
            .sort()
            .join(', ');
    }, [t, offerList]);
    var officeDetailsSampleOrderStartedAt = React.useMemo(function () {
        if (!offerList.officeDetails)
            return;
        return offerList.officeDetails
            .map(function (officeDetail) {
            return "".concat(officeDetail.office.name, ": ").concat(formatDateTimeWithOffset(officeDetail.sampleOrderStartedAt));
        })
            .join('\n');
    }, [offerList.officeDetails]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { container: true, spacing: 1 },
            React.createElement(LabeledGridItem, { label: t('params.offerList.id'), value: offerList.id }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.status'), value: t("params.offerList.statuses.".concat(offerList.status)) }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.paymentTerm'), value: t("params.offerList.paymentTerms.".concat(offerList.paymentTerm)) }),
            React.createElement(LabeledGridItem, { label: t('params.offerListOfficeDetail.sampleOrderStartedAt'), value: officeDetailsSampleOrderStartedAt }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.orderStartedAt'), value: formatDateTimeWithOffset(offerList.orderStartedAt) }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.expiredAt'), value: formatDateTimeWithOffset(offerList.expiredAt) }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.publishDays'), value: offerList.publishDays }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.sampleDeliveryDate'), value: offerList.sampleDeliveryDate }),
            React.createElement(LabeledGridItem, { label: t('params.offerList.publishedCountries'), value: publishedCountries })),
        React.createElement(MaterialTable, { title: t('offers'), model: "offer", columns: columns, data: offerList.offers, actions: [
                function (offer) { return ({
                    icon: function () { return React.createElement(AuctionIcon, null); },
                    hidden: offer.orderType !== 'auction',
                    tooltip: 'Auction',
                    onClick: function () {
                        return navigate("/producer/offer_lists/".concat(offerList.id, "/auctions/").concat(offer.id));
                    },
                }); },
            ] })));
};
export default OfferListDetail;
var templateObject_1;
